import { MessageCircle } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { PROTECTED_ROUTES } from "@/constants/routes";
import { useConversations } from "@/features/messaging/hooks/useConversations";

/** Same pattern as `NotificationBell`: icon button with an unread-count
 * badge, linking to `/chat`. The badge sums each conversation's own
 * `unreadCount` — there's no separate "total unread" endpoint, and summing
 * client-side avoids adding one for a single badge. */
export function ChatIcon() {
  const conversationsQuery = useConversations();
  const unreadCount =
    conversationsQuery.data?.reduce((total, conversation) => total + conversation.unreadCount, 0) ?? 0;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button type="button" variant="ghost" size="icon" aria-label="Chat" asChild>
          <Link to={PROTECTED_ROUTES.chat} className="relative">
            <MessageCircle className="h-4 w-4" aria-hidden="true" />
            {unreadCount > 0 && (
              <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium text-primary-foreground">
                {unreadCount > 9 ? "9+" : unreadCount}
              </span>
            )}
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>Chat</TooltipContent>
    </Tooltip>
  );
}
